/**
 * @generated SignedSource<<891ed2b1a85360938cfe0b88b6ece3eb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ActivityCardTagsFragment$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"CompetitionTagFragment">;
    };
  }>;
  readonly " $fragmentType": "ActivityCardTagsFragment";
};
export type ActivityCardTagsFragment$key = {
  readonly " $data"?: ActivityCardTagsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ActivityCardTagsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ActivityCardTagsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TagEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Tag",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "CompetitionTagFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CompetitionTagConnection",
  "abstractKey": null
};

(node as any).hash = "41dfb10b37c982b3d1a7ca0c769addef";

export default node;
